import { useTranslation } from 'next-i18next';

import { FileFilter } from '@/entities/vfo/types';

export const useFileOptions = () => {
  const { t } = useTranslation('features/vfo', { keyPrefix: 'fileOptions' });

  const fileOptions = [
    {
      label: t('pdf'),
      value: FileFilter.PDF,
    },
    {
      label: t('spreadsheet'),
      value: FileFilter.SPREADSHEET,
    },
    {
      label: t('image'),
      value: FileFilter.IMAGE,
    },
    {
      label: t('textDocument'),
      value: FileFilter.TEXT_DOCUMENT,
    },
  ];

  return fileOptions;
};
